import * as Util from '../Util';

function track(event, props) {
  if (!Util.isProduction()) return;
  if (window.mixpanel && window.mixpanel.track) {
    window.mixpanel.track(event, props);
  }
}

export function logVisitedStep(step, extraProps) {
  track('Visited Onboarding Step', { step, ...(extraProps || {}) });
}

export function logCompletedStep(step, extraProps) {
  track('Completed Onboarding Step', { step, ...(extraProps || {}) });
}

export function logAbandonedStep(step, extraProps) {
  track('Abandoned Onboarding Step', { step, ...(extraProps || {}) });
}

export function logFieldError(step, field, errorMessage, extraProps) {
  track('Onboarding Field Error', { step, field, error: errorMessage, ...(extraProps || {}) });
}

export function logFieldBlurred(step, field, filled, extraProps) {
  track('Onboarding Field Blurred', { step, field, filled, ...(extraProps || {}) });
}
